import { useQuery } from '@tanstack/react-query';

import { getTradeFundStatuses } from '@arrived/api_v2';
import { OfferingTransactionFundStatus, OfferingTransactionId } from '@arrived/models';

import { MAX_STALE_TIME, UseQueryOptions } from '../queries.utils';
import { tradeFundStatusesQueryKeyFn } from './trades.keys';

export function useGetTradeFundStatusesQuery(
  tradeId: OfferingTransactionId,
  options?: UseQueryOptions<OfferingTransactionFundStatus[]>
) {
  return useQuery(tradeFundStatusesQueryKeyFn(tradeId), async () => getTradeFundStatuses(tradeId), {
    staleTime: MAX_STALE_TIME,
    ...options,
  });
}
